import React from 'react';
import { FiCode, FiEdit3, FiBarChart2 } from 'react-icons/fi';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Integrate the SDK",
      description: "Add our lightweight SDK to your mobile app with just a few lines of code. We support both iOS and Android platforms.",
      icon: <FiCode size={24} />
    },
    {
      number: "02",
      title: "Create Your Stories",
      description: "Use our intuitive dashboard to create engaging stories with images, videos, and interactive elements.",
      icon: <FiEdit3 size={24} />
    },
    {
      number: "03",
      title: "Publish & Analyze",
      description: "Schedule your stories, publish them to your users, and track engagement with our comprehensive analytics.",
      icon: <FiBarChart2 size={24} />
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works-container">
        <div className="how-it-works-header">
          <h2 className="section-title" data-aos="fade-up">
            How It <span className="gradient-text">Works</span>
          </h2>
          <p className="section-description" data-aos="fade-up" data-aos-delay="100">
            Get started with StoryCape in three simple steps
          </p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="step-card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="step-icon-container">
                {step.icon}
              </div>
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <svg width="100%" height="100%" viewBox="0 0 100 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 10H100" stroke="url(#gradient)" strokeWidth="2" strokeDasharray="4 4"/>
                    <defs>
                      <linearGradient id="gradient" x1="0" y1="0" x2="100" y2="0" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3ECF8E" stopOpacity="0.5"/>
                        <stop offset="1" stopColor="#3ECF8E" stopOpacity="0"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="workflow-animation" data-aos="fade-up">
          <div className="workflow-line"></div>
          <div className="workflow-dot workflow-dot-1"></div>
          <div className="workflow-dot workflow-dot-2"></div>
          <div className="workflow-dot workflow-dot-3"></div>
        </div>
      </div>
      
      <div className="how-it-works-shapes">
        <div className="hiw-shape hiw-shape-1"></div>
        <div className="hiw-shape hiw-shape-2"></div>
      </div>
    </section>
  );
};

export default HowItWorks;